import React, {useState,useEffect} from 'react';
import {Grid,} from '@material-ui/core'

import { DashboardHeader, MyProductListingCard} from '../../../components'
import './style.scss'
import HttpService from "../../../services/http.service";
import {getUserDataFromLocalStorage} from "../../../services/utils";

function MyProducts(props) {
  const page = props?.match?.path
  // console.log(page);
  const [pageTitle, addNewItem, productValue] = page === '/myproducts' ? ['My Product', 'add new product', true] : ['products to bid', '', false]
  const addNewHandler = () => props.history.push('newproduct')
   const [loading, setLoading] = useState(true)
  const [product, setProduct] = useState([])
  let loginUser = getUserDataFromLocalStorage()
  useEffect(() => {
    setLoading(true)
    HttpService.get('products/getMyProducts?ssoId='+loginUser.ssoId).then(res => {
      if (res) {
        setProduct(res.data)
        setLoading(false)
      }
    });
  }, []);

  return (
    <Grid container direction={'column'} className='p-20 content-main-container'>
      <DashboardHeader pageTitle={pageTitle} addNewItem={addNewItem} addNewHandler={addNewHandler}/>
      <Grid container className='mt-0 mb-20' direction='row'>
        {product.map((item, index) => (
          <MyProductListingCard item={item} product={productValue} index={index} key={index} {...props}/>
        ))}
      </Grid>
    </Grid>
  );
}

export default MyProducts;
